import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import PaywallModal from "../components/PaywallModal";

const PaywallContext = createContext(null);

/**
 * <PaywallProvider /> wraps the app and exposes `openPaywall({ reason })`
 * to any descendant. Any locked tile / button across the app calls this
 * to lift the Stripe upsell.
 *
 * Single source of truth for the modal — keeps Stripe + pricing copy
 * in ONE place. Replace pricing here once, every gate updates.
 */
export function PaywallProvider({ children }) {
  const [state, setState] = useState({ open: false, reason: "", itemTitle: "" });

  const open = useCallback((opts = {}) => {
    setState({
      open: true,
      reason: opts.reason || "premium",
      itemTitle: opts.itemTitle || "",
    });
  }, []);

  const close = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  const value = useMemo(() => ({ open, close }), [open, close]);

  return (
    <PaywallContext.Provider value={value}>
      {children}
      <PaywallModal open={state.open} onClose={close} reason={state.reason} itemTitle={state.itemTitle} />
    </PaywallContext.Provider>
  );
}

export function usePaywall() {
  const ctx = useContext(PaywallContext);
  if (!ctx) {
    // Safe no-op so tests / Storybook-style isolated renders don't crash.
    return { open: () => {}, close: () => {} };
  }
  return ctx;
}
